import defaultValues from "@/constant/defaultValues";
import { isEmpty, map, size, trim } from "lodash";
import Select from "react-select";
import { useState } from "react";

const AirFreight = (props) => {
  const { TERM_LIST, PACKAGING_TYPE } = defaultValues;
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const {
    errors,
    styleError,
    formData,
    handleFocusOut,
    handleChange,
    handleCountryFromChange,
    handleCountryToChange,
    handleTermChange,
    showPickupAddress,
    showDeliveryAddress,
    countries,
    selectedTerm,
    selectedCountryFrom,
    selectedCountryTo,
    handleAddClick,
    handleRemoveClick,
    handleLQPChange,
    handleLQPcbppChange,
    handleLQPFocusOut
  } = props;

  return (
    <>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12"></div>
      <div className="col-xxl-12">
        <hr className="mt-0" />
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.country_from ? "error-show" : ""}`}
          style={{ zIndex: "11" }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select origin country *"
              className="select"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
              classNamePrefix={"Drop-down-menu"}
            />
            {errors.country_from && (
              <span className="invalid-feedback" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.port_of_origin ? "error-show" : ""}`}
          style={{ zIndex: "10" }}
        >
          <div className="input-pad">
            <input
              type="text"
              name="port_of_origin"
              value={formData.port_of_origin}
              className="input"
              autoComplete="off"
              placeholder={`Enter origin airport *`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.port_of_origin && (
              <span className="invalid-feedback" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.country_to ? "error-show" : ""}`}
          style={{ zIndex: "9" }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="country_to"
              options={countries}
              value={selectedCountryTo}
              onChange={handleCountryToChange}
              placeholder="Select destination country *"
              className="select"
              noOptionsMessage={() => "No Country Found"}
              onBlur={handleFocusOut}
              classNamePrefix={"Drop-down-menu"}
            />
            {errors.country_to && (
              <span className="invalid-feedback" style={styleError}>
                {errors.country_to}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.port_of_destination ? "error-show" : ""}`}
          style={{ zIndex: "8" }}
        >
          <div className="input-pad">
            <input
              type="text"
              name="port_of_destination"
              value={formData.port_of_destination}
              className="input"
              autoComplete="off"
              placeholder={`Enter destination airport *`}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.port_of_destination && (
              <span className="invalid-feedback" style={styleError}>
                {errors.port_of_destination}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.commodity ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="commodity"
              value={formData.commodity}
              className="input"
              autoComplete="off"
              placeholder="Enter commodity / product *"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="invalid-feedback" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div className={`input-wrape ${errors.hs_code ? "error-show" : ""}`}>
          <div className="input-pad">
            <input
              type="text"
              name="hs_code"
              value={formData.hs_code}
              className="input"
              autoComplete="off"
              placeholder="Enter Hs Code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="invalid-feedback" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>
      {map(formData.lwh_qty_packaging, (lqp, indx) => {
        const rowError = errors.lwh_qty_packaging?.[indx] || {};
        
        return (
          <div className="col-12" key={indx}>
            <div className="row package-row">
              <div className="col-12 d-lg-none">
                <div className="package-head">
                  <div className="d-flex multi-field-actions">
                    {
                        (indx == (size(formData.lwh_qty_packaging) - 1)) && <div className="btn outlines-round" onClick={handleAddClick}>
                          <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                          </svg>
                      </div>
                    }
                    {
                        size(formData.lwh_qty_packaging) > 1 && <div className="btn outlines-round" onClick={() => handleRemoveClick(indx)}>
                          <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                          </svg>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div className="col-12 col-xxl-5 col-xl-5 col-lg-5">
                <div className={`input-wrape ${rowError.lwh ? "error-show" : ""}`}>
                  <div className="input-pad ">
                    <input
                      type="text"
                      name="lwh"
                      value={trim(lqp.lwh)}
                      className="input"
                      autoComplete="off"
                      placeholder="Enter Length/Width/Height (CM) *"
                      onChange={(e) => handleLQPChange(e,'lwh',indx)}
                      onBlur={() => handleLQPFocusOut(indx,'lwh')}
                    />
                    {rowError.lwh && (
                      <span className="invalid-feedback" style={styleError}>
                        {rowError.lwh}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 col-xxl-2 col-xl-2 col-lg-2">
                <div
                  className={`input-wrape ${rowError.no_qty ? "error-show" : ""}`}
                >
                  <div className="input-pad ">
                    <input
                      type="text"
                      name="no_qty"
                      value={trim(lqp.no_qty)}
                      className="input"
                      autoComplete="off"
                      placeholder="No / Qty *"
                      onChange={(e) => handleLQPChange(e,'no_qty',indx)}
                      onBlur={() => handleLQPFocusOut(indx,'no_qty')}
                    />
                    {rowError.no_qty && (
                      <span className="invalid-feedback" style={styleError}>
                        {rowError.no_qty}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-8 col-xxl-4 col-xl-4 col-lg-4">
                <div
                  className={`input-wrape ${rowError.cbpp ? "error-show" : ""}`}
                  style={{
                    position: "relative",
                    zIndex: openMenuIndex === indx ? 10 : 1
                  }}
                >
                  <div className="input-pad">
                    <Select
                      name="cbpp"
                      options={PACKAGING_TYPE}
                      value={PACKAGING_TYPE.find(opt => opt.value === lqp.cbpp) || null}
                      onChange={(selectedOption) => handleLQPcbppChange(selectedOption, 'cbpp', indx)}
                      placeholder="Select Type of Packaging *"
                      className="select"
                      // onBlur={handleFocusOut}
                      noOptionsMessage={() => "No packaging type Found"}
                      classNamePrefix={"Drop-down-menu"}
                      onMenuOpen={() => setOpenMenuIndex(indx)}
                      onMenuClose={() => setOpenMenuIndex(null)}
                    />
                    {rowError.cbpp && (
                      <span className="invalid-feedback" style={styleError}>
                        {rowError.cbpp}
                      </span>
                    )}
                  </div>
                </div>
              </div>
             <div className="col-xxl-1 col-xl-1 col-lg-1 d-none d-lg-flex align-items-start flex-shrink-0">
  <div className="d-flex multi-field-actions mt-2">
                  {
                      (indx == (size(formData.lwh_qty_packaging) - 1)) && <div className="btn outlines-round" onClick={handleAddClick}>
                        <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                    </div>
                  }
                  {
                      size(formData.lwh_qty_packaging) > 1 && <div className="btn outlines-round" onClick={() => handleRemoveClick(indx)}>
                        <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                    </div>
                  }
                  
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape ${errors.total_weight ? "error-show" : ""}`}
        >
          <div className="input-pad">
            <input
              type="text"
              name="total_weight"
              value={formData.total_weight}
              className="input"
              autoComplete="off"
              placeholder="Enter total weight (kg)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.total_weight && (
              <span className="invalid-feedback" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
        <div
          className={`input-wrape select-wrape ${errors.term ? "error-show" : ""}`}
          style={{ zIndex: "4" }}
        >
          <div className="input-pad select-wrape">
            <Select
              name="term"
              options={TERM_LIST}
              value={selectedTerm}
              onChange={handleTermChange}
              classNamePrefix={"Drop-down-menu"}
              placeholder="Select term type *"
              className="select"
              noOptionsMessage={() => "No Term Found"}
              onBlur={handleFocusOut}
            />

            {errors.term && (
              <span className="invalid-feedback" style={styleError}>
                {errors.term}
              </span>
            )}
          </div>
        </div>
      </div>
      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showPickupAddress.includes(selectedTerm.value) && (
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div
              className={`input-wrape ${errors.pickup_address ? "error-show" : ""}`}
            >
              <div className="input-pad">
                <input
                  type="text"
                  name="pickup_address"
                  value={formData.pickup_address}
                  className="input"
                  autoComplete="off"
                  placeholder="Enter pickup address *"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.pickup_address && (
                  <span className="invalid-feedback" style={styleError}>
                    {errors.pickup_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      {selectedTerm &&
        !isEmpty(selectedTerm) &&
        showDeliveryAddress.includes(selectedTerm.value) && (
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <div
              className={`input-wrape ${errors.delivery_address ? "error-show" : ""}`}
            >
              <div className="input-pad">
                <input
                  type="text"
                  name="delivery_address"
                  value={formData.delivery_address}
                  className="input"
                  autoComplete="off"
                  placeholder="Enter delivery address *"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                {errors.delivery_address && (
                  <span className="invalid-feedback" style={styleError}>
                    {errors.delivery_address}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default AirFreight;